import { query, collection, onSnapshot, limit, orderBy,getDocs,where } from "firebase/firestore";
import { db } from '../../../../../globals/firebase';
import { useEffect, useState } from "react";
import FlatList from 'flatlist-react';
import JobDetail1Page from "../../components/jobs/job-detail1";


function SectionJobsList() {

    const [listadeprompts, setlistadeprompts] = useState([])
    const [hasMoreItems, sethasMoreItems] = useState(false)
    const [Offset, setOffset] = useState(null)

    useEffect(() => {
        loadchanges()
    }, [])


    const showBlank = () => {
        if (listadeprompts.length === 0) {
            return <div>Create your first prompt to list here</div>
        }

        return <div>Create your first prompt to list here</div>
    }

    // const setfirst = async () => {
    //     const getfirst = query(collection(db, "wpm_prompts"), where("public", "==", true), orderBy("datainsert", "desc"), limit(5))
    //     const documentSnapshots = await getDocs(getfirst);
    //     const first = documentSnapshots.docs[0];
    //     setOffset(first)
    //     loadchanges(first, "first")
    // }



    const loadchanges = async () => {

        // const querySnapshot = await getDocs(collection(db, "prompts"));
        // querySnapshot.forEach((doc) => {          
        //   const docinsert = {
        //     id:doc.id,
        //     imageurl: doc.data().imageurl,
        //     prompt:doc.data().prompttext
        //   }

        //   setlistadeprompts(oldList => [...oldList,docinsert] );

        // });

        const userData = localStorage.getItem("user");
        if (!userData) {
            console.warn("User not found in localStorage");
            return;
        }
        
        const user = JSON.parse(userData);
        if (!user.userid) {
            console.warn("User ID not found in user data");
            return;
        }

        const q = query(collection(db, "wpm_prompts"),where("userid", "==", user.userid), orderBy("datainsert", "desc"), limit(50));
        onSnapshot(q, (querySnapshot) => {
            setlistadeprompts([])
            querySnapshot.forEach((doc) => {

                const docinsert = {
                    id: doc.id,
                    imageurl: doc.data().imageurl,
                    prompttitle: doc.data().prompttitle,
                    prompt: doc.data().prompttext,
                    dateinsert: doc.data().datainsert,
                    userid: doc.data().userid,
                    username: doc.data().username,
                    public: doc.data().public

                }
                setlistadeprompts(oldList => [...oldList, docinsert]);
            });
        });

        //console.log(listadeprompts.length)
    }

    return (
        <>
             <div style={{ width: "100%" }}>
                <FlatList
                    list={listadeprompts}
                    displayGrid
                    minColumnWidth="300px"
                    gridGap="20px"
                    srollToTop
                    renderWhenEmpty={showBlank}
                    renderItem={(doc, idx) =>
                        

                        <div key={doc.id} className="masonry-wrap row d-flex">

                            <JobDetail1Page doc={doc}></JobDetail1Page>

                        </div>

                    }
                    
                />

            </div>
            {hasMoreItems == false ?
                    <div  style={{padding:"20px", alignSelf:"center", width:"200px"}}>
                            <button className="site-button" onClick={(e) => { e.preventDefault(); loadchanges(Offset, "last") }}>Load More</button>
                        </div>
                    
                        : ""}

        </>
    )
}

export default SectionJobsList;